<script setup lang="ts">
definePageMeta({ layout: 'auth' })

// SSR middleware 因 token 失效導回時會帶 `?expired=1`（api plugin 的 toast 分支只在 client 端跑、
// hard reload 場景 client 沒機會 fire）。client mount 時讀 flag → 顯示 toast + 洗掉 query。
// vue-sonner 用 dynamic import 避免 SSR module load 撞 Vue 3.5 strict SSR bug（見 app.vue Toaster ClientOnly 註解）。
// 洗 query 用 `history.replaceState` — 不用 `router.replace` 因為它會觸發 Nuxt page hydration cycle
// 把 Toaster 洗掉。延一小段時間再洗確保 toast 已 render 進 DOM。
const route = useRoute()
onMounted(async () => {
  if (route.query.expired !== '1') return
  const { toast } = await import('vue-sonner')
  toast.error('登入憑證已過期，請重新登入')
  setTimeout(() => {
    window.history.replaceState(window.history.state, '', '/login')
  }, 500)
})
</script>

<template>
  <LoginForm />
</template>
